<template>
  <el-form-item
    v-show="item.visible !== false"
    :label="item.code ? generateName('column', item.code) : item.label"
    :prop="item.key"
    :class="{'block':item.block}"
  >
    <el-input
      v-if="item.type==='input' && item.subtype === 'password'"
      v-bind="$attrs"
      v-on="$listeners"
      :type="subtype"
      :placeholder="item.placeholder"
      :disabled="item.disable"
      :readonly="item.readonly"
      :style="{width: item.width}"
      :autosize="item.autosize"
    >
      <i
        slot="suffix"
        title="显示密码"
        @click="changePass"
        style="cursor:pointer;"
        class="el-input__icon el-icon-view"
      />
    </el-input>

    <el-input
      v-else-if="item.type==='input' && item.subtype !== 'password'"
      v-bind="$attrs"
      v-on="$listeners"
      :type="item.subtype"
      :placeholder="item.placeholder"
      :disabled="item.disable"
      :readonly="item.readonly"
      :autosize="item.autosize"
      :rows="item.rows"
      :style="{width: item.width}"
      :maxlength="item.maxlength || 200"
    />

    <input-number
      v-else-if="item.type==='number'"
      v-bind="$attrs"
      v-on="$listeners"
      :min="item.min"
      :max="item.max"
      :decimal1="item.decimal1"
      :append="item.append"
      :prepend="item.prepend"
      :disabled="item.disabled"
      :style="{width: item.width}"
    />

    <el-input-number
      v-else-if="item.type==='input-number'"
      v-bind="$attrs"
      v-on="$listeners"
      :min="item.min"
      :max="item.max"
      :step="item.step"
      :step-strictly="item.stepStrictly"
      :precision="item.precision"
      :size="item.size"
      :disabled="item.disabled"
      :controls="item.controls"
      :controls-position="item.controlsPosition"
      :name="item.name"
      :label="item.label"
      :style="{width: item.width}"
      :placeholder="item.placeholder"
    />

    <el-radio-group
      v-else-if="item.type==='radio'"
      v-bind="$attrs"
      v-on="$listeners"
      :size="item.size || 'mini'"
      :disabled="item.disabled"
      :text-color="item.textColor"
      :fill="item.fill"
      :style="{width: item.width}"
    >
      <component
        :is="item.button?'el-radio-button':'el-radio'"
        v-for="o in item.options || ajaxOptions"
        :key="o.value"
        :label="o.value"
        :disabled="o.disabled"
        :border="item.border"
        :size="item.size"
        :name="item.name"
      >{{ o.code ? generateName('radio', o.code) || o.label : o.label}}
      </component>
    </el-radio-group>

    <el-checkbox
      v-else-if="item.type==='checkbox'"
      v-bind="$attrs"
      v-on="$listeners"
      :true-label="item.trueLabel"
      :false-label="item.falseLabel"
      :disabled="item.disabled"
      :border="item.border"
      :size="item.size"
      :name="item.name"
      :checked="item.checked"
      :indeterminate="item.indeterminate"
    />

    <el-checkbox-group
      v-else-if="item.type==='checkbox-group'"
      v-bind="$attrs"
      v-on="$listeners"
      :size="item.size"
      :disabled="item.disabled"
      :min="item.min"
      :max="item.max"
      :text-color="item.textColor"
      :fill="item.fill"
    >
      <component
        :is="item.button?'el-checkbox-button':'el-checkbox'"
        v-for="(o, index) in item.options||ajaxOptions"
        :key="index"
        :disabled="o.disabled"
        :label="o.value"
        :true-label="o.trueLabel"
        :false-label="o.falseLabel"
        :border="o.border"
        :name="o.name"
        :checked="o.checked"
        :indeterminate="o.indeterminate"
      >{{o.label}}
      </component>
    </el-checkbox-group>

    <el-switch
      v-else-if="item.type==='switch'"
      v-bind="$attrs"
      v-on="$listeners"
      :disabled="item.disabled"
      :width="item.width"
      :style="{width: item.wid}"
      :active-icon-class="item.activeIconClass"
      :inactive-icon-class="item.inactiveIconClass"
      :active-text="item.activeText"
      :inactive-text="item.inactiveText"
      :active-value="item.activeValue"
      :inactive-value="item.inactiveValue"
      :active-color="item.activeColor"
      :inactive-color="item.inactiveColor"
      :name="item.name"
      :validate-event="item.validateEvent"
    />

    <el-rate
      v-else-if="item.type==='rate'"
      v-bind="$attrs"
      v-on="$listeners"
      :max="item.max"
      :disabled="item.disabled"
      :allow-half="item.allowHalf"
      :low-threshold="item.lowThreshold"
      :high-threshold="item.highThreshold"
      :colors="item.colors || ['#99A9BF', '#F7BA2A', '#FF9900']"
      :void-color="item.voidColor"
      :disabled-void-color="item.disabledVoidColor"
      :icon-classes="item.iconClasses"
      :void-icon-class="item.voidIconClass"
      :disabled-void-icon-class="item.disabledVoidIconClass"
      :show-text="item.showText"
      :show-score="item.showScore"
      :text-color="item.textColor"
      :texts="item.texts"
      :score-template="item.scoreTemplate"
    />

    <el-color-picker
      v-else-if="item.type==='color-picker'"
      v-bind="$attrs"
      v-on="$listeners"
      :disabled="item.disabled"
      :size="item.size"
      :show-alpha="item.showAlpha"
      :color-format="item.format"
      :popper-class="item.popperClass"
      :predefine="item.predefine"
    />

    <el-slider
      v-else-if="item.type==='slider'"
      v-bind="$attrs"
      v-on="$listeners"
      :min="item.min"
      :max="item.max"
      :disabled="item.disabled"
      :step="item.step"
      :show-input="item.showInput"
      :show-input-controls="item.showInputControls"
      :input-size="item.inputSize"
      :show-stops="item.showStops"
      :show-tooltip="item.showTooltip"
      :format-tooltip="item.formatTooltip"
      :range="item.range"
      :vertical="item.vertical"
      :height="item.height"
      :label="item.label"
      :debounce="item.debounce"
      :tooltip-class="item.tooltipClass"
      :marks="item.marks"
    />

    <el-select
      v-else-if="item.type==='select'"
      v-bind="$attrs"
      v-on="$listeners"
      :style="{width: item.width}"
      :multiple="item.multiple"
      :disabled="item.disabled"
      :value-key="item.valueKey"
      :size="item.size"
      :clearable="item.clearable"
      :collapse-tags="item.collapseTags"
      :multiple-limit="item.multipleLimit"
      :name="item.name"
      :autocomplete="item.autocomplete"
      :placeholder="item.placeholder"
      :filterable="item.filterable"
      :allow-create="item.allowCreate"
      :filter-method="item.filterMethod"
      :remote="item.remote"
      :remote-method="item.remoteMethod"
      :loading="item.loading"
      :loading-text="item.loadingText"
      :no-match-text="item.noMatchText"
      :no-data-text="item.noDataText"
      :popper-class="item.popperClass"
      :reserve-keyword="item.reserveKeyword"
      :default-first-option="item.defaultFirstOption"
      :popper-append-to-body="item.popperAppendToBody"
      :automatic-dropdown="item.automaticDropdown"
    >
      <el-option
        v-for="(o, index) in item.options || ajaxOptions"
        :key="index"
        :label="o.label"
        :value="o.value"
        :disabled="o.disabled"
      />
    </el-select>

    <el-time-picker
      v-else-if="item.type==='time'"
      v-bind="$attrs"
      v-on="$listeners"
      :readonly="item.readonly"
      :disabled="item.disabled"
      :editable="item.editable"
      :clearable="item.clearable"
      :size="item.size"
      :placeholder="item.placeholder"
      :start-placeholder="item.startPlaceholder"
      :end-placeholder="item.endPlaceholder"
      :is-range="item.isRange"
      :arrow-control="item.arrowControl"
      :align="item.align"
      :popper-class="item.popperClass"
      :picker-options="item.pickerOptions"
      :range-separator="item.rangeSeparator"
      :value-format="item.valueFormat"
      :default-value="item.defaultValue"
      :name="item.name"
      :prefix-icon="item.prefixIcon"
      :clear-icon="item.clearIcon"
    />

    <el-date-picker
      v-else-if="item.type==='date'"
      v-bind="$attrs"
      v-on="$listeners"
      :style="{width: item.width}"
      :readonly="item.readonly"
      :disabled="item.disabled"
      :editable="item.editable"
      :clearable="item.clearable"
      :size="item.size"
      :placeholder="item.placeholder"
      :start-placeholder="item.startPlaceholder"
      :end-placeholder="item.endPlaceholder"
      :type="item.subtype"
      :format="item.format"
      :align="item.align"
      :popper-class="item.popperClass"
      :picker-options="item.pickerOptions"
      :range-separator="item.rangeSeparator"
      :default-value="item.defaultValue"
      :default-time="item.defaultTime"
      :value-format="item.valueFormat"
      :name="item.name"
      :unlink-panels="item.unlinkPanels"
      :prefix-icon="item.prefixIcon"
      :clear-icon="item.clearIcon"
      :validate-event="item.validateEvent"
    />

    <!--<richtext v-else-if="item.type==='richtext'" v-bind="$attrs" v-on="$listeners"></richtext>-->
    <!-- 单张图片上传 -->
    <el-upload
      v-else-if="item.type==='image'"
      class="avatar-uploader"
      :action="item.action"
      :headers="headers"
      :show-file-list="item.show_file_list"
      :accept="item.accept || 'image/jpeg,image/gif,image/png,image/jpeg,image/jpg,image/bmp'"
      :before-upload="beforeAvatarUpload"
      :on-success="handleAvatarSuccess"
      :style="{width: item.width || '350px', height: item.imageHeight}"
    >
      <img v-if="thisValue && imgUrl" :src="imgUrl"
           :style="{width: item.imageWidth || '50px',height: item.imageHeight}">
      <i v-else class="el-icon-plus avatar-uploader-icon"
         :style="{width: item.imageWidth || '50px', height: item.imageHeight, lineHeight: item.imageHeight}"/>
      <template v-if="thisValue && imgUrl">
        <label class="m_img_upload_close" v-if="item.imageWidth"
               :style="{left:  item.imageWidth.substring(0, item.imageWidth.length-2) - 20 + 'px' }"
               @click.stop="closeImg()">
          <i class="el-icon-close"></i>
        </label>
        <label class="m_img_upload_close" v-else
               :style="{left:  '40px'}"
               @click.stop="closeImg()">
          <i class="el-icon-close"></i>
        </label>
      </template>
    </el-upload>
    <!-- 多张图片上传 -->
    <div v-else-if="item.type=== 'mulImage'">
      <el-upload
        :action="item.action"
        class="multiImage"
        list-type="picture-card"
        :headers="headers"
        :file-list="item.fileList"
        :limit="item.limit"
        :accept="item.accept || 'image/jpeg,image/gif,image/png,image/jpeg,image/jpg,image/bmp'"
        :on-preview="handlePictureCardPreview"
        :on-remove="handleRemove"
        :on-exceed="handleExceed"
        :on-success="uploadSuccess"
        :style="{width: item.width || '400px'}"
      >
        <i class="el-icon-plus"></i>
      </el-upload>
      <el-dialog :visible.sync="dialogVisible" append-to-body>
        <img width="100%" :src="dialogImageUrl" alt>
      </el-dialog>
    </div>
    <el-upload
      v-else-if="item.type==='attachment'"
      :on-remove="handleRemove"
      :action="item.action"
      :accept="item.accept"
      :before-remove="beforeRemove"
      multiple
      :headers="headers"
      :limit="item.limit"
      :on-exceed="handleExceed"
      :on-success="uploadSuccess"
      :file-list="item.fileList"
    >
      <el-button size="small">点击上传</el-button>
      <!--<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>-->
    </el-upload>

    <span v-else>未知控件类型</span>
    <p :key="item.key" class="item_hint"
       v-if="item.hint && item.hint.length > 0"
       :style="{fontSize: '12px', color: '#67c23a', width: item.width}"
    >{{ item.hint }}</p>
    <!-- from表单项的说明 -->
    <div class="remark" v-if="item.remark" v-html="item.remark"></div>
  </el-form-item>
</template>

<script>
// import Richtext from '@/components/tinymce'
import request from '@/utils/axios'
import {getToken} from '@/utils/cookie'

export default {
  inheritAttrs: false, // 如果你不希望组件的根元素继承 attribute，你可以在组件的选项中设置 inheritAttrs: false。
  components: {
    // Richtext
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      uuidArray: [],
      ajaxOptions: [],
      isShow: false,
      imgUrl: '',
      headers: {
        'Authorization': 'Bearer ' + getToken()
      }
    }
  },
  computed: {
    thisValue: {
      get() {
        return this.$attrs.value
      },
      set(newValue) {
      }
    },
    subtype() {
      if (this.isShow) {
        return 'text'
      } else {
        return 'password'
      }
    }
  },
  watch: {
    thisValue(value) {
      if (this.item.type === 'image') {
        this.getUrl(value)
      }
    }
  },
  created() {
    if (this.item.type === 'image') {
      this.getUrl(this.thisValue)
    }

    if (this.item.type === 'mulImage') {
      this.getUrlArray(this.thisValue)
    }
    /** **************** 获取下拉框数据 *****************/
    const optionLabel = this.item.optionLabel
    const optionValue = this.item.optionValue
    let type = 'get'
    if (this.item.optionsUrlType) {
      type = this.item.optionsUrlType
    }
    // 传入url
    const optionsUrl = this.item.optionsUrl
    if (optionsUrl) {
      request({
        url: `${optionsUrl}`,
        method: type
      }).then(resp => {
        let data = resp.data
        if (data && data.code === 0) {
          this.ajaxOptions = []
          data.data.forEach((item) => {
            let ajaxData = {}
            ajaxData.label = item[optionLabel]
            if (optionValue) {
              ajaxData.value = item[optionValue]
            } else {
              ajaxData.value = item
            }
            this.ajaxOptions.push(ajaxData)
          })
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
    }
    // 传入function获
    const optionsFun = this.item.optionsFun
    if (optionsFun) {
      optionsFun.then(resp => {
        let data = resp.data
        if (data && data.code === 0) {
          this.ajaxOptions = []
          data.data.forEach((item) => {
            let ajaxData = {}
            ajaxData.label = item[optionLabel]
            if (optionValue) {
              ajaxData.value = item[optionValue]
            } else {
              ajaxData.value = item
            }
            this.ajaxOptions.push(ajaxData)
          })
        }
      })
    }
  },
  methods: {
    // 删除图片
    closeImg(key) {
      this.imgUrl = ''
      this.$emit('changeImage', '')
    },
    // 切换密码可见
    changePass() {
      this.isShow = !this.isShow
    },
    // 获取图片url,根据uuid
    getUrl(uuid) {
      if (!uuid) {
        this.imgUrl = ''
        return
      }
      let getImageUrl = this.item.getAction
      if (!getImageUrl) {
        return
      }
      request({
        url: `${getImageUrl}`,
        method: 'get',
        params: {
          uuid: uuid
        }
      }).then(resp => {
        let data = resp.data
        if (data && data.code === 0) {
          let urlKey = this.item.urlKey || 'url'
          this.imgUrl = data.data[urlKey]
        }
      }).catch(err => {
        console.info(err)
        // this.$message.error(err.message)
      })
    },
    getUrlArray(uuids) {
      this.item.fileList = []
      this.uuidArray = []
      if (!uuids) {
        this.item.fileList = []
        return
      }
      let getImageUrl = this.item.getAction
      if (!getImageUrl) {
        return
      }
      request({
        url: `${getImageUrl}`,
        method: 'get',
        params: {
          uuids: uuids
        }
      }).then(resp => {
        let result = resp.data
        if (result && result.code === 0) {
          let files = result.data
          files.forEach(file => {
            let urlKey = this.item.urlKey || 'url'
            let imgUrl = file[urlKey]
            this.item.fileList.push({
                uuid: file.uuid,
                name: file.name,
                url: imgUrl
              }
            )
            this.uuidArray.push(file.uuid)
          })
        }
      }).catch(err => {
        console.info(err)
        // this.$message.error(err.message)
      })
    },
    // 单个图片上传成功后调用
    handleAvatarSuccess(res, file) {
      this.imgUrl = ''
      this.$emit('changeImage', res.data.uuid)
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 ${this.item.limit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    beforeAvatarUpload(file) {
      let act = this.item.accept
      let isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif'
      if (act && act.length > 0) {
        isJPG = false
        let it = act.indexOf(' ') > -1 ? ', ' : ','
        for (let i = 0; i < act.split(it).length; i++) {
          isJPG = isJPG || file.type === act.split(', ')[i]
        }
      }
      if (!isJPG) {
        this.$message.error('上传图片格式不正确!')
      }
      return isJPG
    },
    // 多张图片批量上传，保存uuid串
    uploadSuccess(response, file, fileList) {
      let fileData = response.data
      let urlKey = this.item.urlKey || 'url'
      let imgUrl = fileData[urlKey]
      this.item.fileList.push({
        uuid: fileData.uuid,
        name: fileData.name,
        url: imgUrl
      })
      this.uuidArray.push(fileData.uuid)
      this.$emit('changeImage', this.uuidArray.join(','))
    },
    handleRemove(file, fileList) {
      let index = this.uuidArray.indexOf(file.uuid)
      if (index > -1) {
        this.uuidArray.splice(index, 1)
      }
      this.item.fileList.splice(this.item.fileList.indexOf(file), 1)
      this.$emit('changeImage', this.uuidArray.join(','))
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    }
  }
}
</script>
<style scoped lang="scss">
  .avatar-uploader {
    position: relative;
    cursor: pointer;
  }

  .m_img_upload_close {
    position: absolute;
    color: red;
    top: -5px;
    left: -10px;
    cursor: pointer;
    font-size: 18px;
  }

  .avatar-uploader-icon:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    font-size: 28px;
    color: #8c939d;
    text-align: center;
  }

  .item_hint {
    margin: 5px 0 0;
    line-height: 18px;
  }

  .remark {
    line-height: 30px;
    color: rgba(0, 0, 0, .45);
  }

</style>

<style>
  .block {
    display: block !important;
    display: flex !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/dynamic-form/item.vue